<template>

    <date-pick 
        class="Dpick"
        :class="{invalid:!isValid}"
        v-model="date"
        :format="format"
        :nextMonthCaption="nextMonthCaption"
        :prevMonthCaption="prevMonthCaption"
        :setTimeCaption="setTimeCaption"
        :weekdays="weekdays"
        :months="months"
        :selectableYearRange="99"
    >

        <template v-slot:default="{toggle, inputValue}">
            <button  class="Dpick__inp" @click.stop.prevent="toggle" v-text="otdo(inputValue)">
            </button>
        </template>

    </date-pick>

</template>

<style lang="scss">
.Dpick {
    margin-right: 15px;
    &__inp {
      border: 1px solid #e0e0e0;
      background: none;
      font-family: 'Bliss';
      font-size: 1rem;
      line-height: 1.62;
      padding: 6px 12px;
      box-shadow: none;
      border-radius: 5px;
      color: #555;
      min-width: 100px;
  }
}    
</style>

<script setup>
import { ref, onMounted, computed } from 'vue'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/src/vueDatePick.scss'

const props=defineProps({
    value: String,
    placeholder: String,
})
const emit=defineEmits(['change'])

const jpick=ref(null)
const isValid=ref(true)
const isFocus=ref(false)
const val=ref('')

const otdo = val => {
    let ret0 =  val ? val : '--.--.--'
    let ret = `${props.placeholder} ${ret0}`
    return ret
}

const date = computed({
    get() {
        return props.value
    },
    set(value) {
//        val.value=value
        emit('change', value)
    }
})


const format = 'DD.MM.YYYY'

const nextMonthCaption='Следующий месяц'
const prevMonthCaption='Предыдущий месяц'
const setTimeCaption='Время';
const weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
const months=[
    'Январь', 'Февраль', 'Март', 'Апрель',
    'Май', 'Июнь', 'Июль', 'Август',
    'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
]


</script>

